var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16884_111223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 7.99935C1.33337 5.48519 1.33337 4.22812 2.11442 3.44706C2.89547 2.66602 4.15255 2.66602 6.66671 2.66602H9.33337C11.8475 2.66602 13.1046 2.66602 13.8856 3.44706C14.6667 4.22812 14.6667 5.48519 14.6667 7.99935V9.33268C14.6667 11.8468 14.6667 13.1039 13.8856 13.8849C13.1046 14.666 11.8475 14.666 9.33337 14.666H6.66671C4.15255 14.666 2.89547 14.666 2.11442 13.8849C1.33337 13.1039 1.33337 11.8468 1.33337 9.33268V7.99935Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 2.66602V1.66602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.66602V1.66602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 6H14.3333",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16884_111223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar 1.041b23ff56b3894cc81e680a68d8429b.svg";
export { ForwardRef as ReactComponent };